// Redux slice for managing output material list loading, data, and errors
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Material } from '../utils/match-maker.types';
import { getMaterialDetail } from './material-detail.thunk';

// State shape for the material detail feature
interface MaterialDetailState {
  loading: boolean;
  materialDetailData?: Material; // Replace with actual data type
  error?: string | null;
}

// Initial state for the material detail slice
const initialState: MaterialDetailState = {
  loading: false,
  materialDetailData: undefined,
  error: null,
};

// Slice for the material detail feature with reducers and extraReducers for async actions
const materialDetailSlice = createSlice({
  name: 'materialDetail',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      // Handle getMaterialDetail pending state
      .addCase(getMaterialDetail.pending, state => {
        state.loading = true;
        state.error = null;
      })

      // Handle getMaterialDetail fulfilled state
      .addCase(
        getMaterialDetail.fulfilled,
        (state, action: PayloadAction<Material>) => {
          state.materialDetailData = action.payload;
          state.loading = false;
        }
      )

      // Handle getMaterialDetail rejected state
      .addCase(getMaterialDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

// Export reducer for store
export default materialDetailSlice.reducer;
